import { Component, OnInit, Input } from "@angular/core";

declare var _: any;

@Component({
  selector: "app-validation-aadhar",
  templateUrl: "./validation-aadhar.component.html",
  styleUrls: ["./validation-aadhar.component.scss"],
})
export class ValidationAadharComponent implements OnInit {
  _data: any;

  @Input()
  set data(value) {
    this._data = value;
  }
  get data() {
    return this._data;
  }
  @Input() form;
  constructor() {}

  ngOnInit() {}
}
